import React, { useState } from 'react';
import { Tabs, Button } from 'antd';
import PartnerReportTable from './PartnerReportTable';
import ProposalSummaryPage from './ProposalSummaryPage';
import ProposalPaymentPage from './ProposalPaymentPage';
import ProposalReportAllDashboard from './ProposalSummaryDashboard';
import ProposalStatusCountsDashboard from './ProposalStatusCountsDashboard';
import MonthlyCompanyDashboard from './MonthlyCompanyDashboard';
import PartnerMonthlyDashboard from './PartnerMonthlyDashboard';
import CompanyProposalStatsTable from './CompanyProposalStats';

const { TabPane } = Tabs;

const ReportTabs: React.FC<any> = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Tabs
      activeKey={activeKey}
      onChange={onChange}
      className="custom-tabs"
      tabBarStyle={{ borderBottom: 'none' }}
    >
      <TabPane
        key="1"
        tab={
          <Button
            type={activeKey === '1' ? 'primary' : 'default'}
            className="d-button tab-button"
          >
            İş Ortakları
          </Button>
        }
      >
        <ProposalReportAllDashboard />
      </TabPane>
      <TabPane
        key="4"
        tab={
          <Button
            type={activeKey === '4' ? 'primary' : 'default'}
            className="d-button tab-button"
          >
            Teklif
          </Button>
        }
      >
        <ProposalStatusCountsDashboard />
      </TabPane>
      <TabPane
        key="5"
        tab={
          <Button
            type={activeKey === '5' ? 'primary' : 'default'}
            className="d-button tab-button"
          >
            Firma Kayıt Raporu
          </Button>
        }
      >
        <MonthlyCompanyDashboard />
      </TabPane>
      

            <TabPane
        key="6"
        tab={
          <Button
            type={activeKey === '6' ? 'primary' : 'default'}
            className="d-button tab-button"
          >
            İş Ortağı Kayıt Raporu
          </Button>
        }
      >
        <PartnerMonthlyDashboard />
      </TabPane>

            <TabPane
        key="7"
        tab={
          <Button
            type={activeKey === '7' ? 'primary' : 'default'}
            className="d-button tab-button"
          >
            Yeni Firma/Teklif Raporu
          </Button>
        }
      >
        <CompanyProposalStatsTable />
      </TabPane>

      <TabPane
        key="2"
        tab={
          <Button
            type={activeKey === '2' ? 'primary' : 'default'}
            className="d-button tab-button"
          >
            Teklifler
          </Button>
        }
      >
        <ProposalSummaryPage />
      </TabPane>

      <TabPane
        key="3"
        tab={
          <Button
            type={activeKey === '3' ? 'primary' : 'default'}
            className="d-button tab-button"
          >
            Ödemeler
          </Button>
        }
      >
        <ProposalPaymentPage />
      </TabPane>
    </Tabs>
  );
};

export default ReportTabs;